import {Injectable} from '@angular/core';
import {Column} from 'asax-common';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class ColumnsService {
  private defaultColumns: Column[];
  private columnsSubject = new BehaviorSubject<Column[]>(undefined);

  getColumns(): Observable<Column[]> {
    return this.columnsSubject.asObservable();
  }

  getColumnsValue(): Column[] {
    return this.columnsSubject.getValue();
  }

  setColumns(columns: Column[]): void {
    this.columnsSubject.next(columns);
  }

  setDefaultColumns(columns: Column[]): void {
    this.defaultColumns = [...columns];
  }

  getDefaultColumns(): Column[] {
    return this.defaultColumns || [];
  }

  upsertColumn(column: Column): void {
    const columns = this.columnsSubject.getValue();
    const index = columns.findIndex(c => c.id === column.id);

    if (index > -1) {
      columns.splice(index, 1);
      columns.splice(index, 0, column);
    } else {
      columns.push(column);
    }

    this.columnsSubject.next(columns.slice());
  }
}
